import * as c from './constants'

const createActionCreator = (actionType) => () => ({ type: actionType })
const createActionCreatorWithPayload = (actionType) => (payload) => {
  return ({ type: actionType, payload })}

export const newUserMessage = createActionCreatorWithPayload(c.NEW_USER_MSG)
export const newUserQuickReply = createActionCreatorWithPayload(c.NEW_USER_QUICK_REPLY)
export const fetchBotResponseSuccess = createActionCreatorWithPayload(c.FETCH_BOT_RESPONSE_SUCCESS)

export const botInit = createActionCreator(c.BOT_INITIALIZED)
export const startConversation = createActionCreatorWithPayload(c.START_CONVERSATION)
export const closeConversation = createActionCreator(c.CLOSE_CONVERSATION)
export const menuItemClick = createActionCreatorWithPayload(c.MENU_ITEM_CLICK)
export const dropdownItemClick = createActionCreatorWithPayload(c.DROPDOWN_ITEM_CLICK)
export const loadHistory = createActionCreator(c.LOAD_HISTORY)
export const startPolling = createActionCreator(c.START_POLLING)
export const stopPolling = createActionCreator(c.STOP_POLLING)



// WEBPACK FOOTER //
// ./src/App/actions.js